import { CommonPortionTypeResponse } from '@/api/services/common/portion-type/common-portion-type.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'
import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisViewDetailChartFilterByEnumAllowed } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-extended/statistical-analysis-view-detail-chart-filters-extended.model'
import { StatisticalAnalysisCommonStats, StatisticalAnalysisContentScrollTable, StatisticalAnalysisDelayAndResponseEnum, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisTimesheetItemSerie } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisDelayAndResponseTimesStatisticsDossierGroupingColumnsCaseEnum {
    CASE_TYPE = 'CASE_TYPE',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PRIORITY = 'PRIORITY',
    CASE_OF_REFERENCE = 'CASE_OF_REFERENCE',
    REGIME = 'REGIME',
    USER = 'USER'
}

export enum StatisticalAnalysisDelayAndResponseTimesStatisticsDossierGroupingColumnsSampleEnum {
    MOST_LIKELY_MORPHOLOGIC_CODE = 'MOST_LIKELY_MORPHOLOGIC_CODE',
    PROCEDURE = 'PROCEDURE',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    SPECIALIST = 'SPECIALIST',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE'
}

export enum StatisticalAnalysisDelayAndResponseTimesStatisticsDossierGroupingColumnsPortionEnum {
    PROTOCOL = 'PROTOCOL',
    PORTION_TYPE = 'PORTION_TYPE'
}

export enum StatisticalAnalysisDelayAndResponseTimesStatisticsDossierGroupingColumnsSubportionEnum {
    SUBPORTION_PRIORITY = 'SUBPORTION_PRIORITY',
    ASSAY = 'ASSAY',
    SUBPORTION_PROTOCOL = 'SUBPORTION_PROTOCOL',
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    ASSAY_GROUP = 'ASSAY_GROUP'
}

export enum StatisticalAnalysisGeneralStatisticsDossierGroupingColumnsCaseEnum {
    CASE_TYPE = 'CASE_TYPE',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PATHOLOGIST = 'PATHOLOGIST',
    DESTINATION_HEALTH_MANAGEMENT_AREA = 'DESTINATION_HEALTH_MANAGEMENT_AREA',
    DESTINATION_CENTER = 'DESTINATION_CENTER',
    DESTINATION_DEPARTMENT= 'DESTINATION_DEPARTMENT',
    DESTINATION = 'DESTINATION',
    PRIORITY = 'PRIORITY',
    REGIME = 'REGIME',
    LABORATORY = 'LABORATORY',
    CASE_OF_REFERENCE = 'CASE_OF_REFERENCE',
    RESIDENT = 'RESIDENT'
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierBaseRequest {
    startDate: string
    endDate: string
    laboratoryIds:number[]
    laboratoryUserId:number
    showValidatedCasesOnly: boolean
}

export interface StatisticalAnalysisDelayAndResponseTimesDetailRequest {
    infoDetail: StatisticalAnalysisTemporalFilterEnum
    caseTypeId?: number
    sampleTypeId?: number
    delayType?: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum
    portionTypeId?: number
    subportionTypeId?: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDetailRequestTable {
    filterTimeSheetId: number
    groupByFields?: string[]
    delayType?: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum
}

export interface StatisticalAnalysisDelayAndResponseTimesDetailRequestChart {
    filterTimeSheetId: number
    // TODO This filter will be SKILL ENUM when exists
    filterType?: Nullable<string>
    filterId?: Nullable<number>
    filterIds?: Nullable<number[]>
    additionalFilterBy?: Nullable<StatisticalAnalysisViewDetailChartFilterByEnumAllowed>
    additionalFilterById?: Nullable<number>
    delayType?: Nullable<StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum>
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayResponseTimeType {
    code: StatisticalAnalysisDelayAndResponseEnum
    translatedName: string
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayStats {
    responseTimeType: StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayResponseTimeType
    name: string
    countTotal: number
    countPercent: number
    mean: number
    max: number
    min: number
    deviation: number
    median: number
    percentile25: number
    percentile90: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseContentTimeStats {
    responseTimeType: StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayResponseTimeType
    countTotal: number
    name: string
    mean: number
    max: number
    min: number
    deviation: number
    median: number
    percentile25: number
    percentile90: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    total: number
}
export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCaseTypeCount extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal{
    caseType: CommonCaseTypeResponse
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSampleTypeCount extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    sampleType: CommonSampleTypeResponse
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortionTypeCount extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    portionType: CommonPortionTypeResponse
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportionTypeCount extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    subportionType: CommonSubportionTypeResponse
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCase extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    caseTypeCount: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCaseTypeCount[]
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSample extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    sampleTypeCount: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSampleTypeCount[]
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortion extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    portionTypeCount: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortionTypeCount[]
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportion extends StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersTotal {
    subportionTypeCount: StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportionTypeCount[]
}

export type StatisticalAnalysisDelayAndResponseTimesDossierResponseHeaders =
    StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersCase |
    StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSample |
    StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersPortion |
    StatisticalAnalysisDelayAndResponseTimesDossierResponseHeadersSubportion

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeries {
    timeSerie: StatisticalAnalysisTimesheetItemSerie
    value: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeriesValue {
    value: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeriesParsed {
    [key: string]: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeriesValue
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentStats {
    deviation: number
    mean: number
    median: number
    maxTime: number
    minTime: number
    percent: number
    total: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentCase {
    user: StatisticalAnalysisViewDetailTableGroupingColumns
    caseType: StatisticalAnalysisViewDetailTableGroupingColumns
    priority: StatisticalAnalysisViewDetailTableGroupingColumns
    caseOfReference: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianCenter: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianDepartment: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianHealthManagementArea: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianPetitioner: StatisticalAnalysisViewDetailTableGroupingColumns
    regime: StatisticalAnalysisViewDetailTableGroupingColumns
    timeSeries: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeries[]
    stats: StatisticalAnalysisCommonStats
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentSample extends StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentCase{
    mostLikelyMorphologicCode: StatisticalAnalysisViewDetailTableGroupingColumns
    procedure: StatisticalAnalysisViewDetailTableGroupingColumns
    sampleType: StatisticalAnalysisViewDetailTableGroupingColumns
    specialist: StatisticalAnalysisViewDetailTableGroupingColumns
    topographicCode: StatisticalAnalysisViewDetailTableGroupingColumns
}

export type StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContent =
    StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentCase |
    StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentSample

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTable {
    content: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContent[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailExternalViewTable {
    content: StatisticalAnalysisExternalListTypes[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsedCase extends Omit<StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentCase, 'timeSeries'>{
    timeSeries: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeriesParsed
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsedSample extends Omit<StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableContentSample, 'timeSeries'>{
    timeSeries: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableTimeSeriesParsed
}

export type StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsed =
    StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsedCase |
    StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsedSample

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewChartGrouping {
    groupById: Nullable<number>
    groupBy: Nullable<string>
    total: number
}

export interface StatisticalAnalysisDelayAndResponseTimesDossierDetailViewChart {
    timeSerie: StatisticalAnalysisTimesheetItemSerie
    groupings: StatisticalAnalysisDelayAndResponseTimesDossierDetailViewChartGrouping[]
}

export type StatisticalAnalysisDelayAndResponseTimesDossierResponseContentStats =
    StatisticalAnalysisDelayAndResponseTimesDossierResponseContentDelayStats |
    StatisticalAnalysisDelayAndResponseTimesDossierResponseContentTimeStats
